<script setup lang="ts">
import { Tippy } from 'vue-tippy';

type Props = {
  type?: 'info';
};

withDefaults(defineProps<Props>(), {
  type: 'info',
});

defineSlots<{
  default(props: unknown): VNode;
  trigger(props: unknown): VNode;
}>();
</script>

<template>
  <Tippy>
    <template #default>
      <slot name="trigger" />
    </template>

    <template #content>
      <div class="content" :class="{ [`content--${type}`]: true }">
        <slot />
      </div>
    </template>
  </Tippy>
</template>

<style lang="scss" scoped>
.content {
  padding: 0.75rem;

  background-color: var(--blue-bright);
  border-radius: 0.375rem;

  font-size: var(--font-size-base);
  color: var(--black);
}
</style>

<style lang="scss">
.tippy-box[data-animation='fade'][data-state='hidden'] {
  opacity: 0;
}

[data-v-tippy] {
  width: calc(1.25rem + 0.25rem);
  height: 1.25rem;
}

[data-tippy-root] {
  max-width: calc(100vw - 0.625rem);
}

.tippy-box {
  position: relative;

  outline: 0;
  transition-property: transform, visibility, opacity;
  overflow: hidden;
}

.tippy-content {
  position: relative;

  z-index: 1;
}
</style>
